<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p>{{ $t('notification.text.showNotification.general') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/notification" />
        </div>
      </div>
    </div>
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :activeFilters="activeFilters"
      :hasCheckbox="false"
      :hasFilter="true"
      searchable
      withCard
      :refreshData="!falseAlertSubmit"
    >
      <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
        <McFilterSelect
          :defaultColumnOrder="initialFields"
          :currentColumnOrder="dataFields"
          @setColumn="handleSetDataFields"
          @setField="handleFieldShow"
        />
      </template>
      <template #button-filter>
        <div class="d-flex justify-content-end">
          <div class="mc-table-filter me-2">
            <date-picker
              ref="notifPeriodPicker"
              v-model="period"
              placeholder="Pilih Tanggal"
              value-type="YYYY-MM-DD"
              format="DD MMM YYYY"
              :shortcuts="makeShortcuts"
              :clearable="false"
              range-separator=" - "
              range
              :confirm="true"
              :confirm-text="$t('global.action.apply')"
              :disabled-date="disabledRange"
              :lang="datePickerLang"
              @input="changeDate"
              @pick="pickDate"
              @close="closePicker"
            >
              <template #footer>
                <McButton
                  class="me-2"
                  variant="outline-primary"
                  :text="$t('global.action.cancel')"
                  @click="closeCalendar()"
                />
              </template>
            </date-picker>
          </div>
          <ModalFilter
            :activeFilters="filterModal"
            :alertCode="alertsFilter"
            :selectedPeriod="period"
            @applyFilters="handleApplyFilters"
          />
        </div>
      </template>
      <template #cell(alert)="data">
        <div class="text-primary clickable-field" @click="openModalNotification(data.item)">
          {{ getNotificationDescription(data.item, data.value) }}
        </div>
      </template>
      <template #cell(createdOn)="data">
        <div class="d-flex flex-column">
          <span>{{ momentDateShortMonth(data.item.createdOn) }}</span>
          <span class="text-muted">{{ momentTimeSeconds(data.item.createdOn) }}</span>
        </div>
      </template>
      <template #cell(vehicle)="data">
        {{ data.value.licensePlate ?? '-' }}
      </template>
      <template #cell(geofence)> - </template>
      <template #cell(alertTrigger)="data">
        {{ convertValue(data.value, data.item.alertCode, 'alertTrigger') }}
      </template>
      <template #cell(alertData)="data">
        {{
          data.item.alertCode == 15 || data.item.alertCode == 16
            ? convertValue(data.item.formattedAlertData, data.item.alertCode, 'alertData')
            : convertValue(data.value, data.item.alertCode, 'alertData')
        }}
      </template>
      <template #cell(address)="data">
        <b-skeleton v-if="getAddress(data) === undefined" width="70%" />
        <span v-else>{{ getAddress(data) }}</span>
      </template>
      <template #cell(falseAlert)="data">
        <span v-if="data.item.lastUserFeedback?.isFalseAlert" class="false-alert-icon">
          <i class="mc-fa icon-fill_checkmark-circle"></i>
        </span>
        <span v-else>{{ '-' }}</span>
      </template>
      <template #cell(falseAlertReason)="data">
        {{ data.item.lastUserFeedback?.isFalseAlert ? data.item.lastUserFeedback?.feedback : '-' }}
      </template>
      <template v-if="hasAccess(['b3e-capture-picture-event:read'])" #cell(media)="data">
        <McButton
          icon="icon-outline_image"
          :text="$t('global.media')"
          variant="outline-primary"
          size="small"
          :disabled="
            data.item.vehicle.sensor.every((data) => data.sensorCode !== 35) ||
            (!jcCode.includes(data.item.vehicle?.device?.deviceCode) &&
              !bsjCode.includes(data.item.vehicle?.device?.deviceCode))
          "
          :displayTooltip="
            data.item.vehicle.sensor.every((data) => data.sensorCode !== 35) ||
            (!jcCode.includes(data.item.vehicle?.device?.deviceCode) &&
              !bsjCode.includes(data.item.vehicle?.device?.deviceCode))
          "
          :tooltipText="$t('global.noMedia')"
          @click="openModalMedia(data.item)"
        />
      </template>
    </McGrapqlTable>
    <b-modal
      id="modal-notification"
      scrollable
      hide-footer
      size="lg"
      centered
      @hide="closeModalNotification"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center">
          <span>
            {{ detailNotification.vehicle ? detailNotification.vehicle.licensePlate : '' }}
            -
            {{
              detailNotification.driver
                ? detailNotification.driver.fullname
                : $t('global.text.noDriver')
            }}
          </span>
          <i class="icon-outline_close" @click="close()" />
        </div>
      </template>
      <div class="mc-modal-fleet mc-modal-fleet--notification">
        <div class="mc-modal-fleet__item">
          <div>
            <div
              class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif clearfix mb-3 mt-0"
            >
              <h4 class="text-secondary float-start">
                {{
                  detailNotification.alert
                    ? $i18n.locale === 'id'
                      ? detailNotification.alert.descriptionIdn
                      : detailNotification.alert.descriptionEng
                    : '-'
                }}
              </h4>
              <div class="float-end text-end">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  disabled
                  :title="$t('notification.action.callDriver')"
                >
                  <i class="mc-fa icon-outline_phone" />
                  {{ $t('notification.action.callDriver') }}
                </button>
                <McButton
                  v-if="hasAccess(['b3e-capture-picture-event:read'])"
                  icon="icon-outline_image"
                  :text="$t('global.media')"
                  variant="primary"
                  class="ms-2"
                  :disabled="
                    detailNotification?.vehicle?.sensor.every((data) => data.sensorCode !== 35) ||
                    (!jcCode.includes(detailNotification?.vehicle?.device?.deviceCode) &&
                      !bsjCode.includes(detailNotification?.vehicle?.device?.deviceCode))
                  "
                  @click="openModalMedia(detailNotification)"
                />
              </div>
            </div>
            <dl class="mc-modal-fleet__item-list clearfix pb-0">
              <dt>{{ $t('global.time.time') }}</dt>
              <dd>
                {{ momentDateShortMonth(detailNotification.createdOn) }} -
                {{ momentTimeSeconds(detailNotification.createdOn) }}
              </dd>
              <dt>{{ $t('global.object.location') }}</dt>
              <dd>{{ detailNotification.address }}</dd>
            </dl>
            <div class="mc-modal-fleet__item-false">
              <div class="d-flex align-items-center">
                <i class="mc-fa icon-fill_bell-off"></i>
                <span class="ms-2">
                  <template v-if="detailNotification?.isFalseAlert">
                    {{ $t('notification.text.falseAlert') }}
                    <strong>{{ detailNotification.lastUserFeedback?.feedback }}</strong>
                  </template>
                  <template v-else>
                    {{ $t('notification.text.isFalseAlert') }}
                  </template>
                </span>
                <div class="ms-auto">
                  <template v-if="formOpen">
                    <McButton
                      :text="$t('global.action.cancel')"
                      variant="secondary"
                      size="sm"
                      class="me-2"
                      @click="formOpen = false"
                    />
                    <McButton
                      :text="$t('global.action.save')"
                      variant="primary"
                      size="sm"
                      @click="saveFalseAlert(true)"
                    />
                  </template>
                  <template v-else>
                    <McButton
                      v-if="detailNotification?.isFalseAlert"
                      :text="`${$t('global.alert.text.cancel')} False Alert`"
                      variant="secondary"
                      size="sm"
                      class="me-2"
                      @click="saveFalseAlert(false)"
                    />
                    <McButton
                      :text="
                        detailNotification?.isFalseAlert
                          ? $t('global.action.change')
                          : $t('notification.text.markFalseAlert')
                      "
                      variant="secondary"
                      size="sm"
                      @click="formOpen = true"
                    />
                  </template>
                </div>
              </div>
              <div v-if="formOpen" class="col-md-6 mt-2">
                <label>
                  {{ $t('notification.text.falseAlertReason') }}
                  <span class="text-danger">*</span>
                </label>
                <FormulateForm v-model="falseAlertForm">
                  <template v-for="reason in falseAlertReasons">
                    <McRadioButton
                      :id="reason.key"
                      :key="reason.key"
                      v-model="falseAlertForm.reason"
                      name="reason"
                      :initialValue="reason.key"
                      :label="`${reason.label}`"
                      class="mb-1"
                    />
                  </template>
                  <FormulateInput
                    v-model="falseAlertForm.others"
                    type="textarea"
                    name="others"
                    :placeholder="$t('notification.text.giveOtherReasons')"
                    validation="max:300,length"
                    :validation-name="$t('notification.text.otherReasons')"
                    error-behavior="live"
                    :disabled="falseAlertForm.reason !== 'others'"
                  />
                </FormulateForm>
              </div>
            </div>
          </div>
        </div>
        <h4
          class="mc-sidebar-liveview__list-notif-more d-block btn btn-outline-primary mt-3 mc-notif-open"
          @click="onClicked(detailNotification)"
        >
          <span class="mc-notif-open-text">
            <i class="mc-fa icon-outline_map" /> {{ $t('global.action.seeDetail') }}
          </span>
        </h4>
      </div>
    </b-modal>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import DatePicker from 'vue2-datepicker'
import datePickerLang from '@/helpers/date-picker-lang'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import McRadioButton from '@/components/McRadioButton'
import { getGeolocation } from '@/services/api/geolocation'
import { mapGetters } from 'vuex'
import {
  GET_RAW_ALERTS_WITH_ADDRESS,
  UPSERT_RAW_ALERTS_ACTION,
} from '@/services/api/driverscore/score'
import { general } from '../lib/alert-code'
import ModalFilter from '../components/ModalFilter.vue'
import McFilterSelect from '@/components/McFilterSelect'
import { GetAddressData } from '@/services/api/map'
import { DEVICE_CODE_LIST } from '@/helpers/device-code'
import cloneDeep from 'lodash/cloneDeep'
import { GET_RAW_ALERT } from '@/services/api/fleet'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    McButton,
    McButtonBack,
    McGrapqlTable,
    ModalFilter,
    McFilterSelect,
    McRadioButton,
  },
  mixins: [Helper],
  data() {
    return {
      jcCode: DEVICE_CODE_LIST.CONCOX_CAMERA,
      bsjCode: DEVICE_CODE_LIST.BSJ,
      activeFilters: {},
      filterModal: {},
      period: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      pastDate: moment().subtract(6, 'months'),
      futureEnd: moment().add(6, 'months'),
      currentPastDate: moment().subtract(6, 'months'),
      currentFutureEnd: moment().add(6, 'months'),
      detailNotification: {},
      addresses: {},
      formatValue: [
        {
          alertCode: [13, 14],
          format: [
            {
              type: 'null-value',
              symbol: '-',
            },
            {
              type: 'suffix',
              symbol: 'global.unit.liter',
            },
          ],
        },
        {
          alertCode: [
            2, 37, 36, 10, 7, 75, 1, 12, 4, 19, 5, 20, 21, 22, 3, 62, 63, 11, 94, 95, 117, 118,
          ],
          format: [
            {
              type: 'value',
              symbol: '-',
            },
          ],
        },
        {
          alertCode: [15, 16, 104],
          format: [
            {
              type: 'null-value',
              symbol: '-',
            },
            {
              type: 're-formatting',
              symbol: 'duration',
            },
          ],
        },
        {
          alertCode: [17, 18],
          format: [
            {
              type: 'null-value',
              symbol: '-',
            },
            {
              type: 'suffix',
              symbol: 'global.unit.celcius',
            },
          ],
        },
      ],
      fieldShow: JSON.parse(localStorage.getItem('generalNotifFields')),
      falseAlertForm: {},
      formOpen: false,
      falseAlertSubmit: true,
    }
  },
  computed: {
    title() {
      return this.$t('global.object.general')
    },
    storedFields() {
      return this.fieldShow.column
    },
    fields() {
      if (this.fieldShow) {
        return this.storedFields
      } else {
        return [
          {
            key: 'alert',
            label: this.$t('notification.field.type'),
            isSortable: false,
            isLocked: true,
          },
          {
            key: 'createdOn',
            label: this.$t('global.field.date'),
            isSortable: false,
          },
          {
            key: 'vehicle',
            label: this.$t('global.object.licensePlate'),
            isSortable: false,
          },
          {
            key: 'driver.fullname',
            label: this.$t('global.object.driverName'),
            isSortable: false,
            formatter: (val) => {
              return val ?? '-'
            },
          },
          {
            key: 'geofence',
            label: this.$t('global.object.geolocation'),
            isSortable: false,
          },
          {
            key: 'address',
            label: this.$t('global.object.location'),
            isSortable: false,
            thClass: 'mc-table--250',
          },
          {
            key: 'alertTrigger',
            isSortable: false,
            label: this.$t('global.object.limit'),
          },
          {
            key: 'alertData',
            isSortable: false,
            label: this.$t('global.field.actual'),
          },
          {
            key: 'falseAlert',
            isSortable: false,
            label: 'False Alert?',
            shown: false,
          },
          {
            key: 'falseAlertReason',
            isSortable: false,
            label: this.$t('notification.field.falseAlertReason'),
            shown: false,
          },
          ...(this.hasAccess(['b3e-capture-picture-event:read'])
            ? [
                {
                  key: 'media',
                  isSortable: false,
                  label: 'Media',
                },
              ]
            : []),
        ]
      }
    },
    alertsFilter() {
      return general.filter((item) => (item.scope == null ? true : item.scope))
    },
    alerts() {
      const data = cloneDeep(this.alertsFilter)
      data.forEach((item) => {
        item.label = this.$t(item.label)
      })
      data.sort((a, b) => {
        let x = a.label.toLowerCase()
        let y = b.label.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      return data
    },
    query() {
      return {
        get: async (filter) => {
          return this.getData(filter)
        },
      }
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    datePickerLang() {
      return datePickerLang()
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last3Days'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 72)
            return [date, new Date()]
          },
        },
      ]
    },
    getNotificationDescription() {
      return (item, value) => {
        if (item.alertCode === 118) {
          return item.alertFlag
            ? this.$t('notification.alert.onlineVehicle')
            : this.$t('notification.alert.offlineVehicle')
        }
        return this.$i18n.locale === 'id' ? value.descriptionIdn : value.descriptionEng
      }
    },
    falseAlertReasons() {
      return [
        {
          key: 'not-valid',
          label: this.$t('notification.text.notValid'),
          value: 'Tidak ada kejadian',
        },
        {
          key: 'wrong-detection',
          label: this.$t('notification.text.wrongDetection'),
          value: 'Terdeteksi sebagai kejadian lain',
        },
        {
          key: 'others',
          label: this.$t('notification.text.otherReasons'),
          value: 'Alasan Lainnya',
        },
      ]
    },
  },
  watch: {
    formOpen(newValue) {
      if (newValue && this.falseAlertForm.reason === 'others') {
        this.falseAlertForm.others = this.detailNotification?.lastUserFeedback?.feedback || null
      }
    },
  },
  mounted() {
    this.handleChangeActiveFilters([
      { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
      { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() },
    ])
  },
  methods: {
    async getData(filter) {
      let filterDate = {}
      let filterAlerts = []
      let otherFilters = {}
      if (Object.keys(this.activeFilters).length > 0) {
        Object.keys(this.activeFilters).forEach((key) => {
          let filterValue = this.activeFilters[key]
          if (key === 'startDate') {
            filterDate[key] = filterValue
          } else if (key === 'endDate') {
            filterDate[key] = filterValue
          } else if (key === 'alertCode') {
            filterValue.map((item) => filterAlerts.push(Number(item)))
          } else if (key === 'isFalseAlert') {
            otherFilters[key] = filterValue ? true : undefined
          } else {
            otherFilters[key] = filterValue
          }
        })
      }

      const alertCode =
        filterAlerts.length !== 0
          ? { alertCode: filterAlerts }
          : { alertCode: this.alerts.flatMap((item) => item.alertCode) }

      const res = await this.$apollo.query({
        query: GET_RAW_ALERTS_WITH_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            ...alertCode,
            ...otherFilters,
            orderBy: JSON.stringify({ createdOn: 'desc' }),
            startDate: filterDate.startDate,
            endDate: filterDate.endDate,
          },
        },
      })

      this.fetchAddresses(res)

      return res.data.rawAlerts.rawAlerts
    },
    async fetchAddresses(res) {
      const useCache = this.isUsingCache()
      const coords = []
      const tempAddresses = { ...this.addresses }

      res.data.rawAlerts.rawAlerts.data.forEach((item) => {
        const lat = Number(item.latitude)
        const lon = Number(item.longitude)
        if (tempAddresses[lat + '&' + lon] === undefined) coords.push({ lat, lon })
      })

      if (coords.length > 0) {
        if (useCache) {
          const addresses = await getGeolocation(coords)

          for (const [key, value] of addresses) {
            tempAddresses[key.replace(',', '&')] = value.name
          }
        } else {
          await Promise.all(
            coords.map(async (coord) => {
              const res = await GetAddressData(coord.lat, coord.lon)
              tempAddresses[res.lat + '&' + res.lon] = res.display_name
            })
          )
        }
      }

      this.addresses = tempAddresses
    },
    getAddress(data) {
      return this.addresses[data.item.latitude + '&' + data.item.longitude]
    },
    handleFilterModal(filters) {
      this.filterModal = {
        alertCode: this.findFilterValue(filters, 'alertCode') || [],
        vehicleId: this.findFilterValue(filters, 'vehicleId') || [],
        driverId: this.findFilterValue(filters, 'driverId') || [],
        period: [
          this.findFilterValue(filters, 'startDate'),
          this.findFilterValue(filters, 'endDate'),
        ],
        geolocationType: this.findFilterValue(filters, 'geofence')?.geofenceSelectionMode || 'All',
        geolocationId: this.findFilterValue(filters, 'geofence')?.geofenceId || [],
        isFalseAlert: this.findFilterValue(filters, 'isFalseAlert'),
      }
    },
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)
        if (filter.values === null || filter.values === undefined) return
        if (Array.isArray(filter.values) && filter.values.length === 0) return
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    convertValue(value, alertCode, type) {
      let result = value

      if (alertCode == 15 || alertCode == 16) {
        value = value * 60
      }

      if (alertCode == 117) {
        if (type == 'alertTrigger') return `4 ${this.$t('global.time.hours')}`
        if (type == 'alertData') return this.minuteToHour(value)
      }

      if (alertCode == 118) {
        if (type == 'alertTrigger')
          return value ? `${value} ${this.$t('global.time.minutes')}` : '-'
      }

      const format = this.formatValue.find((item) => item.alertCode.includes(alertCode))
      if (format) {
        format.format.forEach((item) => {
          if (item.type == 'value') result = item.symbol
          else {
            if (value == null || typeof value === 'undefined' || value == '') {
              if (item.type == 'null-value') result = item.symbol
            } else {
              if (item.type == 'suffix') result = `${value} ${this.$t(item.symbol)}`
              else if (item.type == 're-formatting') {
                if (item.symbol == 'duration') {
                  const timeObject = this.convertTimeToObject(value)
                  result = ''
                  if (timeObject.day) {
                    result += `${timeObject.day} ${
                      timeObject.day > 1 ? this.$t('global.time.days') : this.$t('global.time.day')
                    } `
                  }
                  if (timeObject.hour) {
                    result += `${timeObject.hour} ${
                      timeObject.hour > 1
                        ? this.$t('global.time.hours')
                        : this.$t('global.time.hour')
                    } `
                  }
                  if (timeObject.minute) {
                    result += `${timeObject.minute} ${
                      timeObject.minute > 1
                        ? this.$t('global.time.minutes')
                        : this.$t('global.time.minute')
                    } `
                  }
                  if (timeObject.second) {
                    result += `${timeObject.second} ${
                      timeObject.second > 1
                        ? this.$t('global.time.seconds')
                        : this.$t('global.time.second')
                    }`
                  }
                }
              }
            }
          }
        })
      }
      return result
    },
    async openModalNotification(item) {
      const falseAlert = item.lastUserFeedback
      this.detailNotification = { ...item, falseAlert }
      if (falseAlert) {
        const selectedReason = this.falseAlertReasons.find(
          (item) => item.value === falseAlert.feedback
        )
        this.falseAlertForm.reason = selectedReason ? selectedReason.key : 'others'
        this.falseAlertForm.others = selectedReason ? null : falseAlert.feedback
      }
      this.detailNotification.address = this.addresses[item.latitude + '&' + item.longitude]
      this.$bvModal.show('modal-notification')
    },

    async openModalMedia(item) {
      const response = await this.$apollo.query({
        query: GET_RAW_ALERT,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            rawAlertId: item.rawAlertId,
          },
        },
      })

      const rawAlert = response.data.rawAlert.rawAlert

      this.$store.commit('notification/setDetailNotification', rawAlert)
      this.$store.commit('notification/setListNotificationMedia', rawAlert.media ?? [])

      await this.$nextTick()
      this.$bvModal.show('modal-alert-media')
    },
    onClicked(item) {
      if (!this.hasAccessAll(['e1b-web-umum:read', 'alert_code:read', 'raw_alerts_driver:read'])) {
        return
      }
      localStorage.setItem('drivers-detail-map', JSON.stringify(item))

      this.$router.push({
        name: 'General Detail',
        params: { id: item.vehicle.id },
      })
    },
    changeDate() {
      this.handleChangeActiveFilters([
        { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
        { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() },
      ])
    },
    disabledRange: function (date) {
      let limit = new Date()

      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit
      )
    },
    pickDate(date) {
      const maxDate = 3
      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    closePicker() {
      this.currentPastDate = moment().subtract(6, 'months')
      this.currentFutureEnd = moment().add(6, 'months')
    },
    closeCalendar() {
      this.closePicker()
      this.$refs.notifPeriodPicker.defaultOpen = false
    },
    handleApplyFilters(value) {
      const { period, geolocationType, geolocationId } = Object.fromEntries(
        value.map((item) => [item.key, item.values])
      )

      this.period = period

      const filters = value.filter(
        (item) => !['geolocationType', 'geolocationId', 'period'].includes(item.key)
      )

      filters.push(
        { key: 'startDate', values: moment(`${this.period[0]} 00:00:00`).toISOString() },
        { key: 'endDate', values: moment(`${this.period[1]} 23:59:59`).toISOString() }
      )

      if (geolocationType !== 'All') {
        filters.push({
          key: 'geofence',
          values: { geofenceId: geolocationId, geofenceSelectionMode: geolocationType },
        })
      } else {
        filters.push({
          key: 'geofence',
          values: null,
        })
      }

      this.handleFilterModal(filters)
      this.handleChangeActiveFilters(filters)
    },
    handleFieldShow(fields) {
      localStorage.setItem('generalNotifFields', JSON.stringify({ column: fields }))
    },
    async saveFalseAlert(isFalseAlert) {
      if (
        isFalseAlert &&
        this.falseAlertForm.reason === 'others' &&
        !this.falseAlertForm.others.trim()
      ) {
        this.$mcToast.error(
          `${this.$t('notification.text.otherReasons')} ${this.$t('global.validation.required')}`
        )
        return
      }
      this.falseAlertSubmit = true
      const reasons = this.falseAlertReasons.find((item) => item.key === this.falseAlertForm.reason)
      const input = {
        selectionMode: 'Selection',
        actionType: 'FalseAlert',
        rawAlertId: [this.detailNotification.rawAlertId],
        data: `${isFalseAlert}|${
          reasons.key !== 'others' ? reasons.value : this.falseAlertForm.others
        }`,
      }
      const res = await this.$apollo.mutate({
        mutation: UPSERT_RAW_ALERTS_ACTION,
        variables: {
          input,
        },
      })
      if (!res.data.upsertRawAlertsAction.isSuccessful) {
        this.$mcToast.error(res.data.upsertRawAlertsAction.message)
        this.falseAlertSubmit = false
        return
      }
      const upsertAlert = res.data.upsertRawAlertsAction.upsertRawAlertsAction
      const [isFalseAlertStr, feedbackText] = upsertAlert.data.split('|')
      const falseAlert = isFalseAlertStr === 'true'
      this.falseAlertForm = {}
      this.detailNotification.lastUserFeedback = {
        createdOn: upsertAlert.createdOn,
        userId: upsertAlert.userId,
        feedback: feedbackText || '',
      }
      this.detailNotification.isFalseAlert = falseAlert
      this.formOpen = false
      this.falseAlertSubmit = false
      if (falseAlert) {
        this.$mcToast.success(this.$t('notification.text.falseAlertSuccess'))
      } else {
        this.$mcToast.success(this.$t('notification.text.cancelFalseAlert'))
      }
    },
    closeModalNotification() {
      this.formOpen = false
      this.detailNotification = {}
      this.falseAlertForm = {}
    },
    handleSubmitFalseAlert(value) {
      this.falseAlertSubmit = value
    },
    openNotificationDetail(item) {
      const createdOn = new Date(item.createdOn).getTime()
      const id = `${item.alertCode}-${item.vehicle.id}-${createdOn}`

      this.$router.push({
        name: 'Notification Detail',
        params: {
          id: id,
          type: 'general',
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.false-alert-icon {
  .mc-fa {
    &:before {
      color: $danger;
      font-size: 20px;
    }
  }
}
</style>
